import 'jquery';
import {plenigoLog} from './logger';

/**
 * @see https://docs.datatrans.ch/docs/secure-fields
 * @see https://docs.datatrans.ch/docs/testing-credentials
 *
 */

(function ($, plenigoLog) {
  let el = $('#datatransLightbox');

  if (!el.length) {
    return;
  }

  let config = JSON.parse(el.text());

  plenigoLog.info('open lightbox with', config);

  $('body').trigger('plenigo.datatransLightbox', {
    lib: config.javascriptUrl || '',
    transactionId: config.transactionId || '',
    method: 'checkout',
  });

}(jQuery, plenigoLog));
